import $ from 'jquery'

$(() => {
  const $Szechenyi2020InfoBlock = $(".szechenyi2020_header");

  if (!$Szechenyi2020InfoBlock.length) {
    return;
  }

  const updateSzechenyi2020Position = () => {
    const offset = $('.yco-front-hero').offset();
    const mainPageCoverOffset = offset ? offset.top : 0;
    $Szechenyi2020InfoBlock.css('top', `${mainPageCoverOffset}px`);
  };

  updateSzechenyi2020Position();

  const scrollHandler = () => {
    if ($(document).scrollTop() > 0) {
      $Szechenyi2020InfoBlock.hide();
    } else {
      $Szechenyi2020InfoBlock.show();
    }
  }

  $(document).on('scroll.Szechenyi2020', scrollHandler).trigger('scroll.Szechenyi2020');

  let resizeTimeout;
  $(window).on('resize.Szechenyi2020 orientationchange.Szechenyi2020', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateSzechenyi2020Position();
    }, 100);
  });
});



// WEBPACK FOOTER //
// ./assets/scripts/szechenyi_2020_banner.js